<template>
  <v-snackbar v-model="_snackbar" :timeout="5000" top>
    {{ _text }}
    <template v-slot:action="{ attrs }">
      <v-btn color="blue" text v-bind="attrs" @click="close">
        Chiudi
      </v-btn>
    </template>
  </v-snackbar>
</template>

<script>
import { mapGetters, mapActions, mapMutations } from "vuex";
export default {
  name: "sea-snackbar",
  methods: {
    ...mapActions({
      close: "snackbar/closeSnackbar"
    }),
    ...mapMutations({
      setSnackbar: "snackbar/SET_SNACKBAR",
      setText: "snackbar/SET_MESSAGE"
    })
  },
  computed: {
    ...mapGetters({
      text: "snackbar/message",
      snackbar: "snackbar/snackbar"
    }),
    _snackbar: {
      get() {
        return this.snackbar;
      },
      set(value) {
        this.setSnackbar(value);
      }
    },
    _text: {
      get() {
        return this.text;
      },
      set(value) {
        this.setText(value);
      }
    }
  }
};
</script>

<style></style>
